var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverlay2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.889648,
    width: 39.99,
    height: 39.99,
    rx: 19.995,
    fill: "#FF6B35"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.445 15.4892V21.4562C15.445 21.8982 15.5469 22.3099 15.7505 22.6912C15.9542 23.0726 16.238 23.3846 16.602 23.6272L19.995 25.8892L23.388 23.6272C23.752 23.3846 24.0359 23.0726 24.2395 22.6912C24.4432 22.3099 24.545 21.8982 24.545 21.4562V15.4892L19.995 14.4752L15.445 15.4892ZM14.652 14.3322L19.995 13.1492L25.338 14.3322C25.4854 14.3669 25.6067 14.4449 25.702 14.5662C25.7974 14.6876 25.845 14.8219 25.845 14.9692V21.4562C25.845 22.1149 25.6912 22.7302 25.3835 23.3022C25.0759 23.8742 24.649 24.3422 24.103 24.7062L19.995 27.4492L15.887 24.7062C15.341 24.3422 14.9142 23.8742 14.6065 23.3022C14.2989 22.7302 14.145 22.1149 14.145 21.4562V14.9692C14.145 14.8219 14.1927 14.6876 14.288 14.5662C14.3834 14.4449 14.5047 14.3669 14.652 14.3322ZM19.995 21.2742L18.084 22.2752L18.448 20.1562L16.901 18.6482L19.046 18.3362L19.995 16.3992L20.944 18.3362L23.089 18.6482L21.542 20.1562L21.906 22.2752L19.995 21.2742Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlay2);
export default __webpack_public_path__ + "static/media/Overlay-2.bb132bda8f31cfbdf3403e17638b0892.svg";
export { ForwardRef as ReactComponent };